import { FIELD_TYPE } from "@commonComponents/massUpdate/constants"

export const FIELD_NAMES_MERCH_EXPORT = [
    {
        key: 'procedure',
        text: 'PROCEDURE',
        text_es: 'RÉGIMEN',
        value: '1',
        fieldType: FIELD_TYPE.DROPDOWN,
        level:'merchandise'
    },
    {
        key: 'originCountry',
        text: 'ORIGIN',
        text_es: 'ORIGEN',
        value: '2',
        fieldType: FIELD_TYPE.DROPDOWN,
        level:'merchandise'
    },
    {
        key: 'cusCode',
        text: 'CUS CODE',
        text_es: 'CÓDIGO CUS',
        value: '3',
        fieldType: FIELD_TYPE.FREE_TEXT,
        level:'merchandise'
    },
    {
        key: 'dispatchRegion',
        text: 'REGION OF DISPATCH',
        text_es: 'REGIÓN DE ENVÍO',
        value: '4',
        fieldType: FIELD_TYPE.DROPDOWN,
        level:'merchandise'
    }
]